
export const getTableStorageId = (tableId, currentUser) => {
    return tableId + (currentUser?.id || '');
}
